import { Link, Text } from "@gravity-ui/uikit";
import css from "src/widgets/Footer/Footer.module.scss";

import { IContact } from "../types/contact.ts";

export const FooterContact = ({ item }: { item: IContact }) => {
  return (
    <div className={css.contactItem}>
      <Link
        className={css.footerLink}
        view={"primary"}
        href={item.href}
        target={"_blank"}
      >
        <Text variant="body-2" as="div">
          {item.title}
        </Text>
        <Text variant="caption-2" color="secondary" as="div">
          {item.subtitle}
        </Text>
      </Link>
    </div>
  );
};
